import { Dispatch, Action } from "redux"
import { handleAuthorizedRequest, trackPlaylist } from "../apis"
import { TrackPlaylist } from "../types"
import { getFilterString, getLatestInfos, mapPaginatedDataToCamelCase } from "../utility"

export const INSIGHTS_ACTION = {
  FETCH_TRACK_PLAYLISTS: "@INSIGHT/FETCH_TRACK_PLAYLISTS"
}

export const fetchTrackPlaylists =
  (limit: number, offset: number, filters: { [key: string]: string | number | boolean } | undefined) =>
  async (dispatch: Dispatch<Action>) => {
    await handleAuthorizedRequest(
      async () => {
        const response = await trackPlaylist(`/?limit=${limit}&offset=${offset}${getFilterString(filters)}`, "get")
        const paginatedDatas = mapPaginatedDataToCamelCase<TrackPlaylist>(response.data)
        const groupedMap = new Map<string, TrackPlaylist>()

        const latestInfo: {
          [key: string]: {
            cmSysLastUpdated: string
            position: number
            peakPosition: number
            updated: string
            currentStorefronts: string | null
            removedStorefronts: string | null
          }
        } = getLatestInfos(paginatedDatas.results)

        paginatedDatas.results.forEach((data) => {
          const track_pl_key = `${data.trackId}-${data.playlistId}`
          const existing = groupedMap.get(track_pl_key)

          if (existing) {
            const newAddedAt = data.addedAt || "-"
            const newRemovedAt = data.removedAt || "-"
            existing.addedAt = `${existing.addedAt}, ${newAddedAt}`
            existing.removedAt = `${existing.removedAt}, ${newRemovedAt}`
          } else {
            const latest = latestInfo[track_pl_key]
            groupedMap.set(track_pl_key, {
              ...data,
              removedAt: data.removedAt || "-",
              peakPosition: latest.peakPosition,
              position: latest.position,
              cmSysLastUpdated: latest.cmSysLastUpdated,
              updated: latest.updated,
              currentStorefronts: latest.currentStorefronts,
              removedStorefronts: latest.removedStorefronts
            })
          }
        })
        const groupedResults: TrackPlaylist[] = Array.from(groupedMap.values())
        paginatedDatas.results = groupedResults
        dispatch({
          type: INSIGHTS_ACTION.FETCH_TRACK_PLAYLISTS,
          payload: paginatedDatas
        })
      },
      "Error getting playlists",
      dispatch
    )
  }
